import React from 'react';
import { ChevronRight } from '../Icons';
import Avatar from '../../../Avatar';
import * as Styles from './styles';
export const MyCadastre = ({ link, userName, profilePicture }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Styles.DesktopLinkWrapper, null,
            React.createElement(Avatar, { size: "32px", src: profilePicture }),
            React.createElement(Styles.InfoWrapper, null,
                React.createElement(Styles.Name, null, userName.split(' ')[0]),
                React.createElement(Styles.Myaccount, null, "Minha Conta")),
            React.createElement(Styles.ChevronRightWrapper, null,
                React.createElement(ChevronRight, null))),
        React.createElement(Styles.TabletLinkWrapper, null,
            React.createElement(link.Icon, { size: "16" }),
            link.title)));
};
